import { useOrganization } from "@/hooks/useOrganization";
import { useUser } from "@/hooks/useUser";
import { Organization } from "@/types/Organization";
import AllEarsTitle from "@components/AllEarsTitle";
import { Card, CardContent, CardHeader, CardTitle } from "@components/ui/card";
import { Trans, useLingui } from "@lingui/react/macro";
import { useParams } from "react-router-dom";
import Heading from "../Heading";
import EmailForm from "./partials/EmailForm";
import ReportSubscriptionsTable from "./partials/ReportSubscriptionsTable";
import SearchSubscriptionsTable from "./partials/SearchSubscriptionsTable";

export default function SettingsEmailView() {
  const { t } = useLingui();

  const title = t`E-postpreferenser`;

  // URL state
  const { orgUuid } = useParams<{ orgUuid: Organization["uuid"] }>();

  // Server state
  const { data: userData } = useUser();
  const userId = userData?.ok ? userData.data.id : undefined;

  const { data: orgData } = useOrganization();
  const allowedIntervals = orgData?.ok
    ? orgData.data.plan?.notification_subscription_intervals
    : undefined;

  if (!orgUuid || !userId) {
    return null;
  }

  return (
    <>
      <AllEarsTitle title={title} />

      <Heading
        heading={title}
        description={t`Hantera vilka e-postmeddelanden du vill ta emot och när`}
      />

      <div className="w-full p-4 lg:p-6 max-w-7xl flex flex-col gap-8">
        <Card className="p-0 gap-0">
          <CardHeader className="p-6 pb-4">
            <CardTitle className="text-xl">
              <Trans>E-postpreferenser för bevakningar och rapporter</Trans>
            </CardTitle>
          </CardHeader>

          <EmailForm />

          <CardContent className="px-6 pb-6">
            <SearchSubscriptionsTable
              className="table-fixed"
              orgUuid={orgUuid}
              userId={userId}
              allowedIntervals={allowedIntervals}
            />
            <ReportSubscriptionsTable
              className="table-fixed"
              orgUuid={orgUuid}
              userId={userId}
            />
          </CardContent>
        </Card>
      </div>
    </>
  );
}
